import { useEffect } from 'react'
import { deviceTimeZone } from '@/shared/lib'
import { reportDeviceTimezone } from '../api/timezone'
import { useSession } from './use-session'

// Зона в проекции сотрудника у хаба — последняя увиденная зона его устройства, и
// переставляет её SPA молча, без диалогов и настроек: спрашивать человека значит
// хранить ответ, а он протухает — люди летают, устройство же едет за человеком
// само.
//
// На экране эта зона не нужна ниоткуда: момент показывается в зоне устройства
// смотрящего, спрошенной прямо в момент показа (`shared/lib/datetime`). Хабу она
// нужна для мест, ГДЕ ЭКРАНА НЕТ, — текста алерта бота о встрече: он рендерится
// на сервере и берёт часы из проекции. Административный SPA хаба обновлял бы её
// только при заходе туда, а сотрудник живёт здесь — поэтому зону сообщает
// телемост.
//
// Раз за загрузку: ручка идемпотентна, а переходы между страницами сотрудника —
// не повод повторять запрос. Флаг модульный (не ref): у него ровно та же жизнь,
// что у загрузки страницы.
let reported = false

export function useDeviceTimezoneSync(): void {
  const { session } = useSession()
  // Только сотрудник: у заказчика и гостя проекции в хабе нет, а куки контура
  // ручка не примет.
  const isEmployee = session?.kind === 'employee'

  useEffect(() => {
    if (!isEmployee || reported) return
    const tz = deviceTimeZone()
    // Intl зону не назвал — слать нечего: поле обязательное, а подставить APP_TZ
    // значило бы выдать зону организации за наблюдение о человеке.
    if (!tz) return
    reported = true
    // Fire-and-forget: ошибка не эскалируется и рендер не держит. Цена промаха —
    // текст алерта узнаёт о перелёте к следующей загрузке.
    void reportDeviceTimezone(tz).catch(() => undefined)
  }, [isEmployee])
}
